"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortOrders = void 0;
var SortOrders;
(function (SortOrders) {
    SortOrders["Custom"] = "custom";
    SortOrders["Relevance"] = "relevance";
    SortOrders["Date"] = "date";
    SortOrders["Name"] = "name";
})(SortOrders = exports.SortOrders || (exports.SortOrders = {}));
//# sourceMappingURL=sort-orders.js.map